import React from 'react';
import logo from './logo.png';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          M1LAN27
        </p>
        <p>
          Call me on discord for free nudes: m1lan27#7018
        </p>
      </header>
    </div>
  );
}

export default App;
